import { useMemo } from "react"
import { IntlShape } from "react-intl"
import { ERotationEvent } from "../../enums/animationSettings"
import { message } from "../../messages/animationSettings"

export default function useEventSelection(intl: IntlShape) {
    const rotationEvent = useMemo(
        () => [
            {
                label: intl.formatMessage(message.clickAndDrag),
                value: ERotationEvent.Drag,
            },
            {
                label: intl.formatMessage(message.hover),
                value: ERotationEvent.Hover,
            },
        ],
        [intl],
    )
    return rotationEvent
}
